import {Component, inject, computed} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslocoPipe} from '@jsverse/transloco';
import {
  ProviderTenderInvitationDocumentResponse,
  DownloadTenderInvitationDocumentRequestParams,
  RfqUploadDocumentControllerService,
} from '@frontend/shared-api';
import {ReactiveFormsModule} from '@angular/forms';
import {PanelModule} from 'primeng/panel';
import {rxResource} from '@angular/core/rxjs-interop';
import {DirectusService} from '@frontend/directus';
import {LoadingComponent} from '../../../../../../../shared/components/loading/loading.component';
import {NoDataComponent} from '../../../../../../../shared/components/no-data/no-data.component';
import {ProjectStepBaseReactive} from '../../../../project-base-step/project-base-step-reactive.component';
import {ProviderDocumentUploadComponent} from '../../../../../../provider/tender-wizard/rfq/tender-rfq-6-documents/provider-document-upload/provider-document-upload.component';
import {firstValueFrom} from 'rxjs';
import {FileDownloadService} from '../../../../../../../shared/utils/file-download.service';
import {DocumentPreviewDialogService} from '../../../../../../../shared/components/dialog/document-preview-dialog/document-preview-dialog.service';
import {CardTitleComponent} from '../../../../../../../shared/components/header/card-title/card-title.component';

@Component({
  selector: 'app-step-8-4-2-provider-results-documents',
  imports: [
    CommonModule,
    TranslocoPipe,
    ReactiveFormsModule,
    ProviderDocumentUploadComponent,
    LoadingComponent,
    NoDataComponent,
    PanelModule,
    CardTitleComponent,
  ],
  templateUrl: './step-8-4-2-provider-results-documents.component.html',
})
export class Step842ProviderResultsDocumentsComponent extends ProjectStepBaseReactive {
  private readonly directusService = inject(DirectusService);
  private readonly rfqUploadDocumentController = inject(RfqUploadDocumentControllerService);
  private readonly documentPreviewDialogService = inject(DocumentPreviewDialogService);
  private readonly fileDownloadService = inject(FileDownloadService);

  protected readonly uploadDocumentsCategoryResource = rxResource({
    params: () => true,
    stream: () => this.directusService.loadInvitationUploadDocuments(),
  });

  protected readonly invitationDocumentsResource = rxResource({
    params: () => ({projectId: this.projectId()!}),
    stream: ({params: request}) =>
      this.rfqUploadDocumentController.getTenderInvitationDocumentsForProject({
        projectId: request.projectId,
      }),
  });

  readonly rowVM = computed<ProviderTenderInvitationDocumentResponse[]>(() => {
    return this.invitationDocumentsResource.value() ?? [];
  });

  protected async onPreviewDocument(documentId: number): Promise<void> {
    try {
      const blob = await firstValueFrom(
        this.rfqUploadDocumentController.downloadTenderInvitationDocument({
          projectId: this.projectId()!,
          documentId,
        }),
      );
      this.documentPreviewDialogService.open(blob);
    } catch (err) {
      console.error('Preview failed:', err);
    }
  }

  protected async onDownloadDocument(documentId: number): Promise<void> {
    try {
      const params: DownloadTenderInvitationDocumentRequestParams = {
        projectId: this.projectId()!,
        documentId: documentId,
      };
      const blob = await firstValueFrom(
        this.rfqUploadDocumentController.downloadTenderInvitationDocument(params, 'response'),
      );

      this.fileDownloadService.downloadFromResponse(blob);
      void this.toastService.showSuccessMessage();
    } catch (err) {
      console.error('Download failed:', err);
    }
  }
}
